import { render } from "./HouseStatsComponent.vue?vue&type=template&id=2cdbb1e4&ts=true"
import script from "./HouseStatsComponent.vue?vue&type=script&lang=ts"
export * from "./HouseStatsComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__